/**
 * Drapeaux pays — génération fiable depuis le code ISO (évite les emojis manquants
 * selon l'encodage fichier ou le rendu navigateur).
 */

/**
 * @param {string} isoCode - Code ISO 3166-1 alpha-2 (ex. SN, US)
 * @returns {string} Emoji drapeau ou chaîne vide
 */
export function flagEmojiFromIso(isoCode) {
  if (!isoCode || typeof isoCode !== 'string' || isoCode.length !== 2) {
    return '';
  }
  const upper = isoCode.toUpperCase();
  if (!/^[A-Z]{2}$/.test(upper)) {
    return '';
  }
  return String.fromCodePoint(
    ...[...upper].map((char) => 0x1f1e6 + char.charCodeAt(0) - 65),
  );
}

/**
 * @param {{ code?: string, flag?: string } | null | undefined} country
 * @returns {string}
 */
export function getCountryFlag(country) {
  if (!country) return '';
  return country.flag || flagEmojiFromIso(country.code) || '';
}
